import { PackageType } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/subscription/common/package_type';

export const CONVERT_PLAN_TYPE_TO_PACKAGE_TYPE = {
    pro_essential: PackageType.PRO_ESSENTIAL,
    pro_advanced: PackageType.PRO_ADVANCED,
    fiverr: PackageType.FIVERR,
} as const;
